import { inject, Injectable } from "@angular/core";
import { DevicesConfigType } from "@bitwarden/web-vault/app/models/types/environement-config.type";
import {
  DeviceBiometricRequest,
  LoginDeviceResponse,
} from "@bitwarden/web-vault/app/models/interfaces/login-device.interface";

import { DataRepositoryService } from "../../DataRepository/data-repository.service";

// webpack DefinePlugin replaces process.env.DEVICES with the literal object at build time.
// In Jest (Node.js) it stays as a JSON string, so we parse it when needed.
const _rawDevicesEnv = process.env.DEVICES;
const DEVICES_CONFIG = (
  typeof _rawDevicesEnv === "string" ? JSON.parse(_rawDevicesEnv) : _rawDevicesEnv
) as DevicesConfigType;

@Injectable({
  providedIn: "root",
})
export class LoginDeviceApi {
  private dataRepositoryService = inject(DataRepositoryService);

  private get glossApiUrl(): string {
    const stage = DEVICES_CONFIG.apiStage ? `/${DEVICES_CONFIG.apiStage}` : "";
    return `${DEVICES_CONFIG.url}${stage}`;
  }

  async getDevices(): Promise<LoginDeviceResponse[]> {
    const response = await this.dataRepositoryService.send(
      "GET",
      DEVICES_CONFIG.endpoint.get_devices,
      null,
      true,
      true,
      this.glossApiUrl,
    );
    return (response as { devices: LoginDeviceResponse[] })?.devices ?? [];
  }

  async putDeviceBiometricStatus(
    request: DeviceBiometricRequest,
  ): Promise<LoginDeviceResponse | undefined> {
    const response = await this.dataRepositoryService.send(
      "PUT",
      DEVICES_CONFIG.endpoint.put_current_device_biometric,
      request,
      true,
      true,
      this.glossApiUrl,
    );
    return (response as { device: LoginDeviceResponse })?.device;
  }

  async disableDeviceBiometric(deviceId: string): Promise<void> {
    const path = `${DEVICES_CONFIG.endpoint.get_devices}/${encodeURIComponent(
      deviceId,
    )}/biometric/disable`;
    await this.dataRepositoryService.send("PATCH", path, null, true, true, this.glossApiUrl);
  }
}
